import { toast } from "react-toastify";

import { nextCargoApi } from "../../baseApi";
import { GetSchedulingByDriver, ListSchedulingDeletedByDriver, SaveScheduling, SaveSchedulingClose } from "./scheduling.types";

export const schedulingApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    saveSchedulingClose: build.mutation<SaveSchedulingClose["result"], SaveSchedulingClose["args"]>({
      query: (body) => ({
        url: "/scheduling/close",
        method: "POST",
        body
      }),
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          pending: "Encerrando atendimento do motorista...",
          success: "Atendimento do motorista encerrado com sucesso!",
          error: "Erro ao encerrar atendimento do motorista!"
        });
      }
    }),
    saveScheduling: build.mutation<SaveScheduling["result"], SaveScheduling["args"]>({
      query: (body) => ({
        url: "/scheduling/save",
        method: "POST",
        body
      })
    }),
    getSchedulingsByDriver: build.query<GetSchedulingByDriver["result"], GetSchedulingByDriver["args"]>({
      query: ({ id }) => `/scheduling/driver/${id}`
    }),
    listSchedulingDeletedByDriver: build.infiniteQuery<ListSchedulingDeletedByDriver["result"], ListSchedulingDeletedByDriver["args"], ListSchedulingDeletedByDriver["pageParam"]>({
      infiniteQueryOptions: {
        initialPageParam: { page: 0, pageSize: 50 },
        getNextPageParam: (lastPage, _, lastPageParam) => {
          const nextPage = lastPageParam.page + 1;
          const remainingPages = lastPage?.total - nextPage;

          if (remainingPages <= 0) {
            return undefined;
          }

          return {
            ...lastPageParam,
            page: nextPage
          };
        },
        getPreviousPageParam: (_, __, firstPageParam) => {
          const prevPage = firstPageParam.page - 1;
          if (prevPage < 0) return undefined;

          return {
            ...firstPageParam,
            page: prevPage
          };
        }
      },
      query: ({ queryArg: { id, ...params }, pageParam }) => ({
        url: `/schedulingDeleted/driver/${id}`,
        params: Object.assign({}, pageParam, params)
      })
    })
  })
});

schedulingApi.enhanceEndpoints({
  addTagTypes: ["SchedulingsByDriver", "SchedulingDeletedByDriver"],
  endpoints: {
    saveSchedulingClose: {
      invalidatesTags: ["SyncExpedition"]
    },
    saveScheduling: {
      invalidatesTags: ["SyncExpedition"]
    },
    getSchedulingsByDriver: {
      providesTags: (result, err, { id }) => [{ type: "SchedulingsByDriver", id }]
    },
    listSchedulingDeletedByDriver: {
      providesTags: (result, err, { id }) => [{ type: "SchedulingDeletedByDriver", id }]
    }
  }
});
